import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";
import { API_URL } from "const/constants";

const getPriceListByIdAPI = async (id) => {
  const response = await axios.get(`${API_URL}/pricelists/${id}`);
  return response?.data ?? null;
};

const getCheckListByIdAPI = async (id) => {
  const response = await axios.get(`${API_URL}/check-list/${id}`);
  return response?.data ?? null;
};

const REFERENCE_QUERY_OPTIONS = {
  retry: false,
  refetchOnWindowFocus: false,
  staleTime: 5 * 60 * 1000,
};

export const usePriceListById = (id) =>
  useQuery({
    queryKey: ["priceListById", id],
    queryFn: () => getPriceListByIdAPI(id),
    enabled: Boolean(id),
    ...REFERENCE_QUERY_OPTIONS,
  });

export const useCheckListById = (id) =>
  useQuery({
    queryKey: ["checkListById", id],
    queryFn: () => getCheckListByIdAPI(id),
    enabled: Boolean(id),
    ...REFERENCE_QUERY_OPTIONS,
  });

export const getPriceListLabel = (item) => {
  if (!item) return "";
  const charges = [
    item.normalServiceCharge ? `Normal ${item.normalServiceCharge}` : null,
    item.minimumServiceCharge ? `Min ${item.minimumServiceCharge}` : null,
    item.maximumServiceCharge ? `Max ${item.maximumServiceCharge}` : null,
  ]
    .filter(Boolean)
    .join(" · ");
  return [item.module || "Price list", charges].filter(Boolean).join(" — ");
};

export const getPriceListTitle = (item, fallbackId) =>
  item?.module || (fallbackId ? `Price list #${fallbackId}` : "Price list");

export const getCheckListLabel = (item) => {
  if (!item) return "";
  const title = String(item.key1 || "")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return title || `Checklist #${item.id}`;
};

export const getCheckListTitle = (item, fallbackId) =>
  getCheckListLabel(item) || (fallbackId ? `Checklist #${fallbackId}` : "Checklist");
